import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltCommentsSidebarDocumentFilterDropdownContent = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-document-filter-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
export default VeltCommentsSidebarDocumentFilterDropdownContent;
